import { createTheme } from '@mui/material/styles';

export const BRAND = '#287094';
export const BRAND_HOVER = '#1f5975';
export const BRAND_TINT = 'rgba(40, 112, 148, 0.08)';
export const BRAND_TINT_STRONG = 'rgba(40, 112, 148, 0.16)';


export const theme = createTheme({
  shape: { borderRadius: 8 },
  palette: {
    primary: {
      main: BRAND,
      dark: BRAND_HOVER,
      contrastText: '#fff',
    },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600 },
      },
      variants: [
        {
          props: { variant: 'cancel' },
          style: {
            border: '1px solid #e5e7eb',
            backgroundColor: '#fff',
            color: '#374151',
            '&:hover': {
              backgroundColor: '#eef2f6',
              borderColor: '#9aa7b4',
              color: '#1f2937',
            },
          },
        },
      ],
    },
    MuiIconButton: {
      variants: [
        {
          props: { variant: 'action' },
          style: { padding: '6px', width: 34, height: 34 },
        },
        {
          props: { variant: 'actionFill' },
          style: { padding: 0, width: 34, height: 34 },
        },
      ],
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: ({ theme }) => ({ color: theme.palette.error.main }),
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 12 },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: { backgroundColor: '#fff', fontWeight: 600 },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          backgroundColor: '#f6f8fa',
          // MUI zeroes the top padding right after a title; keep the gap.
          '.MuiDialogTitle-root + &': { paddingTop: 20 },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: { backgroundColor: '#fff', padding: '12px 24px', gap: 8 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          '&.Mui-disabled': {
            backgroundColor: '#f3f4f6',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#e5e7eb',
            },
          },
          '&:not(.Mui-error):not(.Mui-disabled)': {
            '& .MuiOutlinedInput-notchedOutline': { borderColor: BRAND },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: BRAND },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: BRAND,
              borderWidth: 1,
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: { color: BRAND },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: BRAND,
          '&.Mui-checked, &.MuiCheckbox-indeterminate': { color: BRAND },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': { backgroundColor: BRAND_TINT },
          '&.Mui-selected': {
            backgroundColor: BRAND_TINT_STRONG,
            color: 'inherit',
            fontWeight: 600,
            '&:hover, &.Mui-focusVisible': {
              backgroundColor: BRAND_TINT_STRONG,
            },
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: BRAND,
            color: '#fff',
            '&:hover': { backgroundColor: BRAND_HOVER },
          },
        },
      },
    },
  },
});

export default theme;
